import React from "react";
import { EmptyHeaderCell } from "../../result/table/partials/EmptyHeaderCell";
import useLoadFavorites from "../useLoadFavorites";

export function FavoritesEmptyCell() {
	useLoadFavorites();

	return <EmptyHeaderCell />;
}
